import cx from 'classnames'
import { useState } from 'react'

import classNames from './styles.module.scss'


const totalStars = 5

interface IProps {
  onChange: (value: number) => () => void,
  value: number,
  className?: string,
  disableHover?: boolean,
}

StarsInput.defaultProps = {
  value: 0,
  className: '',
  disableHover: false,
}

export default function StarsInput({
  className,
  disableHover,
  onChange,
  value,
}: IProps): JSX.Element {
  const [filledStars, setFilledStars] = useState(value)

  const handleStarHover = (starIndex: number) => {
    setFilledStars(starIndex + 1)
  }

  const handleStarLeave = () => {
    setFilledStars(0)
  }

  return (
    <div
      className={cx(classNames.starList, className)}
      onMouseLeave={handleStarLeave}
      data-test="stars-input"
    >
      {Array.from({ length: totalStars }).map((_, index) => (
        <i
          className={cx(
            classNames.star,
            index < filledStars && !disableHover && classNames.filled,
            index < value && classNames.filled,

          )}
          key={index}
          onMouseEnter={() => handleStarHover(index)}
          onClick={onChange(index + 1)}
          data-test="stars-input-icon"
        />
      ))}
    </div>
  )
}
